import styled, { keyframes } from "styled-components";

const dotFlashing = () => keyframes`
  0% {
    background-color: ${({ color }) => color};
  }
  50%,100% {
    background-color: rgba(62, 61, 169, 0.2);
  }
`;

export const ZaiaReaction = styled.div`
  width: 100%;
  height: auto;
  text-align: center;
  margin: auto;
  align-items: center;
  padding: ${({ padding }) => (padding ? padding : "")};
  flex-direction: column;
  img {
    width: ${(p) => p.widthimg};
    margin-bottom: ${(p) => p.separation};
  }
  .zaia-reaction-text {
    font-family: ${(p) => (p.weighttext ? "Nunito Sans Bold" : "Nunito Sans")};
    color: ${(p) => (p.textColor ? p.textColor : "#37379B")};
    width: ${($widthText) => $widthText};
    margin: auto;
  }
  .reaction-text {
    display: flex;
    flex-direction: ${({ loadingpoints }) => (loadingpoints ? "" : "column")};
    .zaia-reaction-text {
      font-size: ${(p) => (p.sizeText ? p.sizeText : "1.5em")};
      margin-top: 20px;
    }
    .zaia-reaction-subtext {
      margin-top: ${(p) => (p.sizeBetweenText ? p.sizeBetweenText : "20px")};
      font-size: ${(p) => (p.sizeSubText ? p.sizeSubText : "1em")};
      color: #37379b;
    }
  }
  .loader-container {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    padding: 1rem;

    margin: 0 auto; // 👈 IMPORTANTE

    width: fit-content;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 1.5rem; // gap-6
    padding: 1rem; // p-4
    background: var(--surface-container-high);
    border-radius: 9999px; // rounded-full
    border: 1px solid rgba(var(--outline-variant), 0.1);

    .loader-icon {
      position: relative;

      // tamaño base del logo
      width: ${(p) => p.widthimg};
      height: ${(p) => p.widthimg};

      display: flex;
      align-items: center;
      justify-content: center;

      // 👉 variable base
      --size: ${(p) => p.widthimg};
      --ring-size: calc(var(--size) * 1.8); // tamaño del spinner
      --radius: calc(var(--ring-size) / 2 + 10px);

      .spinner {
        position: absolute;
        width: var(--ring-size);
        height: var(--ring-size);
        border-radius: 50%;

        border: 3px solid transparent;
        border-top: 3px solid #4db4ff;
      }

      .logo {
        z-index: 10;
        width: var(--size);
        height: var(--size);

        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .orbit {
        position: absolute;
        width: var(--ring-size);
        height: var(--ring-size);

        display: flex;
        align-items: center;
        justify-content: center;

        .dot {
          width: calc(var(--size) * 0.04);
          height: calc(var(--size) * 0.04);

          background: #4db4ff;
          border-radius: 50%;

          transform: translateX(var(--radius));
        }
      }
    }
  }
`;

export const ZaialoadingPoints = styled.div`
  padding: 8px 18px;
  align-self: flex-end;
  .dot-flashing {
    position: relative;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: ${({ color }) => color};
    color: ${({ color }) => color};
    animation: ${dotFlashing()} 1s infinite linear alternate;
    animation-delay: 0.5s;
  }
  .dot-flashing::before,
  .dot-flashing::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
  }
  .dot-flashing::before {
    left: -10px;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: ${({ color }) => color};
    color: ${({ color }) => color};
    animation: ${dotFlashing()} 1s infinite alternate;
    animation-delay: 0s;
  }
  .dot-flashing::after {
    left: 10px;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: ${({ color }) => color};
    color: ${({ color }) => color};
    animation: ${dotFlashing()} 1s infinite alternate;
    animation-delay: 1s;
  }
`;
